var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDefaultProfileImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 26,
    viewBox: "0 0 27 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13.4023,
    cy: 13,
    r: 12.5,
    fill: "#603888",
    stroke: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_320_6105)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.02972 11.4168C10.2661 11.4168 11.2684 10.428 11.2684 9.20838C11.2684 7.98873 10.2661 7 9.02972 7C7.79332 7 6.79102 7.98873 6.79102 9.20838C6.79102 10.428 7.79332 11.4168 9.02972 11.4168Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.7114 11.4168C17.9478 11.4168 18.9501 10.428 18.9501 9.20838C18.9501 7.98873 17.9478 7 16.7114 7C15.475 7 14.4727 7.98873 14.4727 9.20838C14.4727 10.428 15.475 11.4168 16.7114 11.4168Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.40234 15.2732C6.40234 15.2732 12.2298 17.9271 19.4023 15.2732C19.4023 15.2732 17.9941 19.0001 13.2544 19.0001C8.51478 19.0001 6.40234 15.2732 6.40234 15.2732Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_320_6105"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13,
    height: 12,
    fill: "white",
    transform: "translate(6.40234 7)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultProfileImage);
export default __webpack_public_path__ + "static/media/defaultProfileImage.97dd8e3b9ccd1f1292f302b64d72a260.svg";
export { ForwardRef as ReactComponent };